import algoliasearch from 'algoliasearch/lite';
import { connectRefinementList } from 'react-instantsearch-dom';

export const searchClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_SEARCH_KEY
);

export const VirtualRefinementList = connectRefinementList(() => null);
